/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.5.3(793ede49d53dba79d39e52205f16321278f5183c)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.zh-cn", {
	"vs/base/common/errors": [
		"{0}。错误代码: {1}",
		"权限被拒绝 (HTTP {0})",
		"权限被拒绝",
		"{0} (HTTP {1}: {2})",
		"{0} (HTTP {1})",
		"未知连接错误 ({0})",
		"出现未知连接错误。您的 Internet 连接已断开，或者您连接的服务器已脱机。",
		"{0}: {1}",
		"出现未知错误。有关详细信息，请参阅日志。",
		"发生了系统错误({0})",
		"出现未知错误。有关详细信息，请参阅日志。",
		"{0} 个(共 {1} 个错误)",
		"出现未知错误。有关详细信息，请参阅日志。",
		"未实施",
		"非法参数: {0}",
		"非法参数",
		"非法状态: {0}",
		"非法状态",
		"无法加载需要的文件。您的 Internet 连接已断开，或者您连接的服务器已脱机。请刷新浏览器并重试。",
		"未能加载所需文件。请重启应用程序重试。详细信息: {0}",
	],
	"vs/base/common/keyCodes": [
		"Windows",
		"控件",
		"Shift",
		"Alt",
		"命令",
		"Windows",
		"Ctrl",
		"Shift",
		"Alt",
		"命令",
		"Windows",
	],
	"vs/base/common/severity": [
		"错误",
		"警告",
		"信息",
	]
});